package horcrux.frontend.common.views.chat

import react.MutableRefObject
import web.html.HTMLInputElement

internal fun MutableRefObject<HTMLInputElement>.focus() = this.current?.focus()
